import { CONFIGS, useConfigQuery } from '@buildwise/libs/configurations';
import { TextFieldController } from '@buildwise/libs/ui';
import { FormControl, TextField, Autocomplete } from '@mui/material';
import useUserData from 'hooks/useUserData';
import { orderBy } from 'lodash';
import { SyntheticEvent, useMemo } from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { FieldWrapper } from '@buildwise/libs/people';
import { ModifyUserFormSchema } from '../../hooks/useUserForm';

function UserDefaultFields() {
  const { companyId } = useUserData();
  const {
    control,
    formState: { isSubmitting },
    setValue,
  } = useFormContext();
  const { activeUniqueEntries } = useConfigQuery({
    companyId,
    configName: CONFIGS.JOB_TITLES.configName,
  });
  const jobTitlesOptions = useMemo(
    () => orderBy(activeUniqueEntries.map((entry) => entry.entryCode)),
    [activeUniqueEntries],
  );

  return (
    <>
      <FieldWrapper id="firstname" label="First Name" required disabled={isSubmitting}>
        <TextFieldController<ModifyUserFormSchema>
          name="firstname"
          TextFieldProps={{ id: 'firstname', autoFocus: true }}
        />
      </FieldWrapper>

      <FieldWrapper id="lastname" label="Last Name" required disabled={isSubmitting}>
        <TextFieldController<ModifyUserFormSchema>
          name="lastname"
          TextFieldProps={{ id: 'lastname' }}
        />
      </FieldWrapper>

      <FieldWrapper id="email" label="Email" disabled={isSubmitting}>
        <TextFieldController<ModifyUserFormSchema>
          name="email"
          TextFieldProps={{
            id: 'email',
            tabIndex: -1,
            disabled: true,
            InputProps: { readOnly: true },
          }}
        />
      </FieldWrapper>

      <FieldWrapper id="title" label="Job Title" required disabled={isSubmitting}>
        <Controller
          control={control}
          render={({ field: { ref, ...field }, fieldState, ...rest }) => (
            <FormControl fullWidth>
              <Autocomplete
                {...field}
                freeSolo
                autoHighlight
                value={field.value || null}
                onChange={(_: SyntheticEvent<Element>, value: string | null) =>
                  setValue('title', value || '', { shouldDirty: true, shouldValidate: true })
                }
                onInputChange={(_: SyntheticEvent<Element>, value: string) =>
                  setValue('title', value || '', { shouldDirty: true, shouldValidate: true })
                }
                options={jobTitlesOptions}
                noOptionsText="No Job Titles Found"
                id="title"
                renderInput={(params) => (
                  <TextField
                    {...params}
                    id="title"
                    inputRef={ref}
                    error={!!fieldState.error}
                    helperText={fieldState?.error?.message || ''}
                    InputLabelProps={{ shrink: true }}
                    variant="standard"
                    placeholder="Job Title"
                    disabled={rest.formState.isSubmitting}
                  />
                )}
              />
            </FormControl>
          )}
          name="title"
        />
      </FieldWrapper>
      {/* <FieldWrapper id="primaryCompanyName" label="Company Name" disabled={isSubmitting}>
        <TextFieldController<ModifyUserFormSchema>
          name="primaryCompanyName"
          TextFieldProps={{
            id: 'primaryCompanyName',
            tabIndex: -1,
            disabled: true,
            InputProps: { readOnly: true },
          }}
        />
      </FieldWrapper> */}
    </>
  );
}

export default UserDefaultFields;
